import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { prototypeDataApi } from '../lib/mockApi';
import { googleSheetsApi } from '../lib/googleSheetsApi';
import type { PrototypeData } from '../lib/mockApi';
import type { ContactFormData, TeamApplicationData } from '../lib/googleSheetsApi';

export function useSubmitContactForm() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: ContactFormData) => {
      return googleSheetsApi.submitContactForm(data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['contactSubmissions'] });
    },
  });
}

export function useSubmitTeamApplication() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: TeamApplicationData) => {
      return googleSheetsApi.submitTeamApplication(data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['teamApplications'] });
    },
  });
}

export function useGetPrototypeData() {
  return useQuery<PrototypeData>({
    queryKey: ['prototypeData'],
    queryFn: async () => {
      return prototypeDataApi.get();
    },
  });
}
